package diana.soleil.design.iraniancanadienbazzar.feature.feed

import kotlinx.coroutines.flow.MutableStateFlow
import kotlinx.coroutines.flow.StateFlow

/**
 * Hand-off for opening a specific post's comments from outside the Feed tab (a tapped comment
 * notification). The Feed is a tab inside the main scaffold with no standalone post route, so the
 * comments sheet is keyed by post id in [FeedRoute]. The app shell [request]s a post id; the scaffold
 * switches to the Feed tab and [FeedRoute] observes [pendingCommentsPostId], opens the sheet, then
 * [consume]s. A process-wide object (not DI) so notification taps can set it before composition.
 */
object FeedDeepLinks {
    private val _pendingCommentsPostId = MutableStateFlow<String?>(null)
    val pendingCommentsPostId: StateFlow<String?> = _pendingCommentsPostId

    fun requestComments(postId: String) {
        if (postId.isNotBlank()) _pendingCommentsPostId.value = postId
    }

    fun consume() {
        _pendingCommentsPostId.value = null
    }

    // "Ask the mahaleh": the shell (global Post sheet) or search's empty state requests the feed
    // composer opened in Question mode; the composer consumes after acting on it.
    private val _pendingAsk = MutableStateFlow(false)
    val pendingAsk: StateFlow<Boolean> = _pendingAsk

    fun requestAsk() {
        _pendingAsk.value = true
    }

    fun consumeAsk() {
        _pendingAsk.value = false
    }
}
